module.exports = __webpack_public_path__ + "static/media/Julius.ffe00ba2.png";